import React, { useEffect } from 'react';

interface GlobalSpinnerProps {
  show: boolean;
}

export const GlobalSpinner: React.FC<GlobalSpinnerProps> = ({ show }) => {
  // Bloquear scroll do corpo quando o spinner estiver visível
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  if (!show) return null;

  return (
    <div 
      className={`fixed inset-0 bg-white z-[99999] flex items-center justify-center transition-opacity duration-500 ${
        show ? 'opacity-100 visible' : 'opacity-0 invisible'
      }`}
      style={{ 
        transition: show 
          ? 'opacity 0.5s ease-out, visibility 0s linear 0s' 
          : 'opacity 0.5s ease-out, visibility 0s linear 0.5s'
      }}
    >
      <div className="relative">
        {/* Bootstrap-style spinner */}
        <div 
          className="border-4 border-gray-200 border-t-orange-600 rounded-full animate-spin"
          style={{ width: '3rem', height: '3rem' }}
          role="status"
        >
          <span className="sr-only">Carregando...</span>
        </div>
      </div>
    </div>
  );
};